import Vue from "vue"
import Vuex from "vuex"

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        LANGUAGE: "en",
        knowledgeLabel:{},
        DocNoLabel:"",
        modalStatus:false,
        uploadFileType:[]
    },
    mutations: {
        SAVELANGUAGE(state, language) {
            state.LANGUAGE = language
            localStorage.language = language
        },
        SAVEKNOWLEDGE(state, knowledgeLabel){
            state.knowledgeLabel = knowledgeLabel
        },
        SAVEDOCNOLABEL(state, DocNoLabel){
            state.DocNoLabel = DocNoLabel
        },
        SAVEMODALSTATUS(state, modalStatus){
            state.modalStatus = modalStatus
        },
        SAVEUPLOADFILETYPE(state, uploadFileType){
            state.uploadFileType = uploadFileType
        },
    },
    actions: {
        SAVELANGUAGE(state, language) {
            state.commit("SAVELANGUAGE", language)
        },
        SAVEKNOWLEDGE(state, knowledgeLabel){
            state.knowledgeLabel = knowledgeLabel
        },
        SAVEDOCNOLABEL(state, DocNoLabel){
            state.DocNoLabel = DocNoLabel
        },
        SAVEMODALSTATUS(state, modalStatus){
            state.modalStatus = modalStatus
        },
        SAVEUPLOADFILETYPE(state, uploadFileType){
            state.uploadFileType = uploadFileType
        },
    }
})


// WEBPACK FOOTER //
// ./src/store/index.js